"use client"
/* */
import { useState, useEffect } from 'react';

const useIsMounted = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return isMounted;
};

export { useIsMounted };
//# sourceMappingURL=useIsMounted.mjs.map
